import type { ListQueryParams } from '@/types/api';

/**
 * Flattens { filter: { status: 'active' } } into { 'filter[status]': 'active' }
 * — the query-string shape Core\QueryParams expects on the backend —
 * and drops empty/undefined values so they don't show up as literal
 * "undefined" strings in the request.
 */
export function buildListParams(params: ListQueryParams): Record<string, string | number> {
  const result: Record<string, string | number> = {};

  if (params.page) result.page = params.page;
  if (params.per_page) result.per_page = params.per_page;
  if (params.search) result.search = params.search;
  if (params.sort) result.sort = params.sort;
  if (params.order) result.order = params.order;

  if (params.filter) {
    for (const [key, value] of Object.entries(params.filter)) {
      if (value !== undefined && value !== null && value !== '') {
        result[`filter[${key}]`] = value as string | number;
      }
    }
  }

  return result;
}
